import React from 'react';
import { Phone, Search, Sparkles, Heart, ArrowRight, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';

const HowItWorksSection = () => {
  const steps = [
    {
      number: "01",
      icon: Phone,
      title: "Premier Contact",
      description: "Appelez ou envoyez un message WhatsApp pour exposer votre situation en toute confidentialité. Le grand marabout africain est disponible 7j/7, 24h/24 pour vous écouter."
    },
    {
      number: "02",
      icon: Search,
      title: "Analyse de votre Situation",
      description: "Le spécialiste du retour affectif analyse les énergies en présence grâce à ses dons de voyance. Il identifie les blocages et détermine le rituel le plus efficace."
    },
    {
      number: "03",
      icon: Sparkles,
      title: "Réalisation du Rituel",
      description: "Le grand marabout effectue le rituel de retour affectif adapté à votre cas : magie blanche, noire ou rouge. Les rituels ancestraux sont puissants et agissent rapidement."
    },
    {
      number: "04",
      icon: Heart,
      title: "Votre Ex Revient",
      description: "Dans les 24 à 72 heures, votre ex commence à ressentir le besoin de vous recontacter. Les sentiments se ravivent et votre couple se reforme."
    }
  ];

  return (
    <section className="py-16 sm:py-28 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-20">
          <span className="inline-block px-4 sm:px-5 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-500 text-xs sm:text-sm font-semibold tracking-wide mb-4 sm:mb-6">
            Comment ça marche ?
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-8 px-2">
            <span className="text-amber-500">4 Étapes</span> pour Récupérer votre Ex
          </h2>
          <p className="text-gray-300 text-base sm:text-xl max-w-3xl mx-auto leading-relaxed px-2">
            Le processus de retour affectif avec le grand marabout africain est simple, rapide et efficace. 
            Voici comment récupérer votre ex en quelques jours seulement.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <article className="bg-gray-900/50 border border-amber-500/10 rounded-2xl p-6 sm:p-8 h-full hover:border-amber-500/30 transition-all duration-300">
                {/* Step Number */}
                <div className="text-6xl sm:text-7xl font-extrabold text-amber-500/10 absolute top-4 right-4">
                  {step.number}
                </div>
                
                {/* Icon */}
                <div className="w-14 h-14 bg-amber-500/10 rounded-xl flex items-center justify-center mb-6 relative z-10">
                  <step.icon className="w-7 h-7 text-amber-500" />
                </div>
                
                {/* Content */}
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-4 relative z-10">{step.title}</h3>
                <p className="text-gray-400 text-sm sm:text-base leading-relaxed relative z-10">{step.description}</p>
              </article>
              
              {/* Arrow */}
              {index < steps.length - 1 && (
                <div className="hidden lg:flex absolute top-1/2 -right-4 transform -translate-y-1/2 z-20">
                  <ArrowRight className="w-8 h-8 text-amber-500/30" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-300 text-lg mb-6">Prêt à récupérer votre ex ? Commencez maintenant !</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
              className="inline-flex items-center justify-center px-8 py-5 bg-amber-500 text-black font-bold text-lg rounded-full hover:bg-amber-400 transition-all duration-300 hover:scale-105"
            >
              <Phone className="w-5 h-5 mr-3" />
              Appelez : {contactInfo.phone}
            </a>
            <a
              href={contactInfo.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-5 bg-green-600 hover:bg-green-700 text-white font-bold text-lg rounded-full transition-all duration-300 hover:scale-105"
            >
              <MessageCircle className="w-5 h-5 mr-3" />
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
